import React from 'react';
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys';
import RefreshListActions from './RefreshListActions';

const Refresh = () => {
  return <RefreshListActions refreshInterval="10000" />;
};

export default onlyUpdateForKeys([
  'resource',
  'filters',
  'displayedFilters',
  'filterValues',
  'theme'
])(Refresh);



// WEBPACK FOOTER //
// ./src/components/Refresh.js